<template>
  <DropdownContainer
    :modal-size="'large'"
    :event-bus="eventBus"
    ref="dropdownContainerSearchAgentOverlay"
  >
    <SearchAgent
      :event-bus="eventBus"
      :search-request-id="searchRequestId"
      :max-result-count-for-creation-exceeded="
        maxResultCountForCreationExceeded
      "
      :suggested-name="suggestedName"
      ref="searchAgentComponent"
    ></SearchAgent>
  </DropdownContainer>
</template>

<script>
import { app } from '@/main'
import mitt from 'mitt'

import SearchAgent from './SearchAgent.vue'
import DropdownContainer from '@shared/DropdownContainer/DropdownContainer.vue'

export default {
  components: {
    SearchAgent,
    DropdownContainer,
  },
  data() {
    return {
      eventBus: mitt(),
      searchRequestId: 0,
      maxResultCountForCreationExceeded: false,
      suggestedName: '',
    }
  },
  methods: {
    closeForm() {
      this.$refs.searchAgentComponent?.reset()

      const owner = this
      setTimeout(() => {
        owner.$refs.dropdownContainerSearchAgentOverlay.close()
      }, 150)
    },
    openForm(searchValue, searchAgentSuggestedName, searchAgentCountExceeded) {
      this.searchRequestId = searchValue
      this.suggestedName = searchAgentSuggestedName
      this.maxResultCountForCreationExceeded = searchAgentCountExceeded

      if (searchAgentCountExceeded) {
        app.toast.info(
          'Søgningen er for omfattende. Begræns den til maximalt 1000 søgeresultater'
        )
      } else {
        this.$refs.dropdownContainerSearchAgentOverlay.open()

        const owner = this
        setTimeout(() => {
          owner.eventBus.emit('search-agent-focus-name')
        }, 100)
      }
    },
  },
  created() {
    if (this.eventBus === null) return
    this.eventBus.on('overlay-closing', this.closeForm)
    this.eventBus.on('search-agent-overlay-close', this.closeForm)
  },
  beforeUnmount() {
    if (this.eventBus === null) return
    this.eventBus.off('overlay-closing', this.closeForm)
    this.eventBus.off('search-agent-overlay-close', this.closeForm)
  },
}
</script>
